import { Field } from 'Util/Query';

export class PromotionQuery {
    constructor() {
        this.options = {};
    }

    getQuery(options) {
        this.options = options;
        const { slug } = this.options;

        return new Field('promotions')
            .addArgument('filters', 'PromotionsFilterInput!', `{slug: { eq: ${slug} }}`)
            .addFieldList(this._getPromotionFields());
    }

    _getPromotionFields() {
        return [
            'id',
            'slug',
            'conditions',
            'conditions_expanded',
            'before_products',
            'products',
            'after_products',
            this._getPromotionsFeaturedField(),
            this._getPromotionsHeroField()
        ];
    }

    _getPromotionsFeaturedField() {
        return new Field('featured')
            .addFieldList(this._getPromotionsFeaturedFields());
    }

    _getPromotionsFeaturedFields() {
        return [
            'text_color_list'
        ];
    }

    _getPromotionsHeroField() {
        return new Field('hero')
            .addFieldList(this._getPromotionsHeroFields());
    }

    _getPromotionsHeroFields() {
        return [
            'title',
            'subtitle',
            'button_text',
            'background_color',
            'background_image',
            'background_image_mobile',
            'show_text',
            'button_url_view'
        ];
    }
}

export default new PromotionQuery();
